// Named imports let esbuild tree-shake the unused keys out of this ~172KB JSON
// file. A default import (`import constants from ...`) would ship all of it.
import { states as schemaStates } from 'vets-json-schema/dist/constants.json';

// create an object of states using this pattern - {abbreviation}: {full name}
// e.g. "DC": "District of Columnbia"
const states = schemaStates.USA.reduce(
  (stateList, { value, label }) => ({
    ...stateList,
    [value]: label,
  }),
  {},
);

const militaryStates = ['AA', 'AE', 'AP'];
const militaryCities = ['APO', 'FPO', 'DPO'];

export default { states, militaryStates, militaryCities };
